module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/fin/reciept_vouchers/reciept_vouchers-show/reciept_vouchers-show.component.scss
// module id = ./src/app/views/fin/reciept_vouchers/reciept_vouchers-show/reciept_vouchers-show.component.scss
// module chunks = main